import React from "react";
import ReactDOM from "react-dom";

// Dialogue de confirmation façon "Abandonner ce contenu ?" (LiveRecordModal) — repris tel quel
// (fond sombre, carte #1c1c1e, action destructive en rouge puis séparateur puis annuler en blanc)
// pour remplacer les window.confirm() natifs du navigateur dans Messages.
export function ConfirmSheet({ title, description, confirmLabel, onConfirm, onCancel }: {
  title: string; description?: string; confirmLabel: string; onConfirm: () => void; onCancel: () => void;
}) {
  // Portail direct sur document.body — même bug/fix que DatePromptSheet.tsx : un position:fixed
  // descendant du conteneur mobile de Layout.tsx (WebkitOverflowScrolling:"touch") se positionne
  // sur Safari iOS par rapport au contenu défilant plutôt qu'au vrai viewport.
  return ReactDOM.createPortal(
    <div onClick={onCancel} style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.55)", zIndex: 2100, display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
      <div onClick={e => e.stopPropagation()} style={{ backgroundColor: "#1c1c1e", borderRadius: 16, padding: "22px 20px", width: "100%", maxWidth: 320, textAlign: "center" }}>
        <div style={{ color: "white", fontWeight: 700, fontSize: 15.5, marginBottom: 8 }}>{title}</div>
        {description && <div style={{ color: "rgba(255,255,255,0.6)", fontSize: 12.5, marginBottom: 18 }}>{description}</div>}
        <button onClick={onConfirm} style={{ width: "100%", padding: "12px", borderRadius: 10, border: "none", backgroundColor: "transparent", color: "#e74c3c", fontSize: 14, fontWeight: 700, cursor: "pointer", marginBottom: 4 }}>{confirmLabel}</button>
        <div style={{ height: 1, backgroundColor: "rgba(255,255,255,0.1)", margin: "4px 0" }} />
        <button onClick={onCancel} style={{ width: "100%", padding: "12px", borderRadius: 10, border: "none", backgroundColor: "transparent", color: "white", fontSize: 14, fontWeight: 600, cursor: "pointer" }}>Annuler</button>
      </div>
    </div>
  ,
    document.body
  );
}
